import Vue from "vue";
import Router from "vue-router";

import auth from "./auth";
import Dashboard from "./components/Dashboard.vue";
import Download from "./components/Download.vue";
import Login from "./components/Login.vue";

Vue.use(Router);

function requireAuth(to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
}

export default new Router({
  mode: "hash",
  base: __dirname,
  routes: [
    {
      path: "/",
      component: Dashboard,
      beforeEnter: requireAuth
    },
    {
      path: "/download",
      component: Download,
      beforeEnter: requireAuth
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/logout",
      beforeEnter(to, from, next) {
        auth.logout(() => {
          next("/login");
        });
      }
    }
  ]
});
